import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

type TProps = {
    endTime: string;
};

const CountdownTimer = ({ endTime }: TProps): JSX.Element => {
    const [days, setDays] = useState(null);
    const [hours, setHours] = useState(null);
    const [minutes, setMinutes] = useState(null);
    const [seconds, setSeconds] = useState(null);
    // const [remainingTime, setRemainingTime] = useState(null);

    const intervalRef = useRef<number>();

    useEffect(() => {
        timer(); // to stop original delay
        intervalRef.current = setInterval(timer, 1000);

        return () => clearInterval(intervalRef.current);
    }, []);

    const timer = () => {
        const endDate = endTime;
        const countDownDate = new Date(endDate).getTime();
        const now = new Date().getTime();
        const distance = countDownDate - now;
        const dayz = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hourz = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutez = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const secondz = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }

            setDays(0);
            setHours(0);
            setMinutes(0);
            setSeconds(0);
        } else {
            setDays(dayz);
            setHours(hourz);
            setMinutes(minutez);
            setSeconds(secondz);
        }
    };

    const showDays = !!days; // not null nor zero
    const showHours = !!hours || (!!days && hours === 0);
    const showMins = !days && (!!minutes || minutes === 0);
    const showSecs = !days && !hours && (!!seconds || seconds === 0);

    return (
        <Container>
            {showDays && (
                <span>
                    {days}d<span className="blinker">:</span>
                </span>
            )}
            {showHours && (
                <span>
                    {`0${hours}`.slice(-2)}h{showMins && <span className="blinker">:</span>}
                </span>
            )}
            {showMins && (
                <span>
                    {`0${minutes}`.slice(-2)}m{showSecs && <span className="blinker">:</span>}
                </span>
            )}
            {showSecs && <span>{`0${seconds}`.slice(-2)}s</span>}
        </Container>
    );
};

const Container = styled.div`
    .blinker {
        margin: 0 2px;
        display: inline-block;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
`;

export default CountdownTimer;
